import React, { useEffect, useState } from 'react';
import '../../css/subscription.css';
import { getProductData } from '../../utilities/subscriptionFunctions';
//#45bcaa8a
function SubscriptionOption({subscription, handleStartSubcription}) {
   const [productInfo, setProductInfo] = useState({})

    const hydrateProductInfo = async () => {
        try {
            const productData = await getProductData()

            if(productData.metadata.subscription_features){
                // subscription_features should be a CSV of features
                productData.metadata.subscription_features = productData.metadata.subscription_features.split(',')
            } else {
                productData.metadata.subscription_features = []
            }

            setProductInfo(productData.metadata ? {...productData.metadata} : {}) // pricing info is in the meta data
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(()=>{
        hydrateProductInfo()
    }, [])

    return (
        <div className="subscriptionOptionWrapper">
            <div className="quilityNestedBlockHeader subscriptionOptionHeader">
                <div className="subscriptionTitle">Funnel Base Subscription</div>
            </div>
            <div className="subcriptionOptionContent">
                <div className="subscriptionOptionPrice">
                    $59.99 Per Month
                </div>
                <div className="subscriptionOptionDescription">
                    <div className="subscriptionOptionDescriptionTitle">Your Subscription Includes</div>
                    <div className="quilityDataLine">{productInfo.minutes} Minutes</div>
                    <div className="quilityDataLine">{productInfo.sms} SMS</div>
                    <div className="quilityDataLine">{productInfo.mms} MMS</div>
                    {Array.isArray(productInfo.subscription_features) > 0 ?
                        <>
                            {productInfo.subscription_features.map((feature, index) => (
                                <div key={`subscription_features_${index}`} className="quilityDataLine">
                                    {feature}
                                </div>
                            ))}
                        </>
                    : (
                        <>
                            <div className="quilityDataLine">Dynamic Scripting</div>
                            <div className="quilityDataLine">Product Reccomendations</div>
                            <div className="quilityDataLine">Product Quotes</div>
                            <div className="quilityDataLine">Two Numbers</div>
                        </>
                    )}
                    <div className="quilityDataLine">
                        <div className="statusItem solidQuilityActiveButton" onClick={()=>handleStartSubcription()}>Subscribe</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubscriptionOption;
